module.exports = __webpack_public_path__ + "media/images/dime-giving-logo-85090aee0075f36a754d3b00b7865b19.png";